<template>
<div>
	<el-dialog title="权益IP配置"
		:visible.sync="openDialog"
		width="600px"
		:before-close="handleDialogCloseAnoths"
		>
		<div style="height: 300px;overflow: auto;" v-loading="loading">
			<div class="title">请配置当前等级（ <span style="color:#7B61FF">{{formData.name}} </span>）的权益IP</div>
			<div style="margin: 20px;">
				<el-upload
					ref="upload"
					action="#"
					list-type="picture-card"
					:on-change="(file, fileList) => {handleChange(file, fileList,'benefitIpUrl')}"
					:on-remove="(file, fileList) => {handleRemove(file, fileList,'benefitIpUrl')}"
					:http-request="httpRequest"
					:file-list="fileList"
					:limit="1"
					:before-upload="beforeUpload"
					:class="fileList.length == 1?'hide_box':''"
				>
					<i class="el-icon-plus"></i>
				</el-upload>
				<div style="color: red; font-size: 14px;margin: 20px 0 0 0;">建议尺寸：345px*204px，图片大小不能超过300kb，类型：JPG、PNG</div>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
				<el-button @click="cancelAdd" class="cancel_Btn">取 消</el-button>
				<el-button type="primary" class="sure_Btn" @click="saveData()">确 定</el-button>
		</span>
		</el-dialog>
</div>
</template>

<script>
import {uploadpic,saveBenefitIp } from "@/api/brandCustom/brandMemberCenter";
export default {
name: '' ,
components: {},
props:{
	openDialog:{
		type:Boolean,
	},
	editData:{
		type:Object
	}
},
data() {
return {
	loading:false,
	formData:{},
	fileList:[],
}
},
computed: {},
created() {

},
mounted() {
	this.formData = JSON.parse(JSON.stringify(this.editData))
	if(this.formData.benefitIpUrl){
		this.fileList = [
				{
					url: this.formData.benefitIpUrl,
					name: "权益IP配置",
				},
			];
	}
},
methods: {
		saveData(){
			if(!this.formData.benefitIpUrl){
				this.$message.warning("权益IP配置不可为空！");
        return;
			}

			let params = {
				benefitIpUrl:this.formData.benefitIpUrl,
				levelId:this.formData.id
			}

			saveBenefitIp(params).then((res) => {
				if (res.code == 1) {
					this.$message.success("操作成功");
					this.$emit('saveData')
				}else{
					this.$message.error(res.message);
				}
			});

		},
		//上传图片
		handleChange(file, fileList,item) {
			const isLt3M = file.size < 1024 * 300;
			if (!isLt3M) {
				this.$message.error("文件大小不符合要求，请重新上传");
				this.$refs.upload.clearFiles();
				return
			} else {
				this.fileList = fileList;
				this.$refs.upload.$children[1].$el.style.display = "none";
				// this.objectForm.name = file.name;
				let formdata = new FormData();
				formdata.append("file", file.raw);
				uploadpic(formdata,2).then((res) => {
					if(res.code == 1){
							// 获取图片真实url
							this.formData.benefitIpUrl = res.data.fileUrl;
					}else{
						this.$message.error(res.message);
						this.fileList=[];
						this.$refs.upload.clearFiles();
						this.formData.benefitIpUrl = "";
						this.$refs.upload.$children[1].$el.style.display = "inline-block";
					}
				});
				
			}
		},
		handleRemove(file, fileList,item) {
		// this.fileList = [];
		// this.$refs.upload.clearFiles();
		this.formData.benefitIpUrl = "";
		this.$refs.upload.$children[1].$el.style.display = "inline-block";
		}, 
		beforeUpload(file) {
		let fileType
		if (this.limitType) {
			const typeArry = [".jpg", ".png", ".JPG", ".PNG"];
			const type = file.name.substring(file.name.lastIndexOf("."));
			const isImage = typeArry.indexOf(type) > -1;
			if (!isImage) {
				fileType = false;
				this.$message({
					message: "图片格式不符合要求，请重新上传！",
					type: "warning",
				});
			}
		} else {
			fileType = true;
		}
		return fileType;
		},
		httpRequest() {},

		// 取消添加
		cancelAdd() {
			this.$emit('cancel')
		},
		handleDialogCloseAnoths() {
			this.$emit('cancel')
		}
}
}
</script>
<style lang='scss' scoped>
/deep/.hide_box .el-upload--picture-card{
    display: none;
}
</style>